import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme, { isSidePanel }: { isSidePanel?: boolean } = {}) => ({
  contentContainer: {
    padding: theme.spacing.sm,
    paddingTop: 0,
    paddingBottom: 0,
    background: isSidePanel ? theme.white : theme.colors.gray[1],
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    width: isSidePanel ? '100%' : theme.other.screenWidth.lg,
    maxWidth: '100%',
    display: 'flex',
  },
  description: {
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  },
  main: {
    paddingTop: theme.spacing.md,
    paddingBottom: theme.spacing.xl * 1.5,
    flexGrow: 1,
    width: '100%',
    overflow: 'hidden',

    ...(isSidePanel
      ? {}
      : {
          [theme.fn.largerThan('md')]: {
            paddingRight: '32px',
            paddingTop: '36px',
          },
        }),
  },
  locationBanner: {
    marginBottom: theme.spacing.xl,
  },
  side: {
    paddingTop: theme.spacing.xl * 1.5,
    paddingBottom: theme.spacing.xl * 1.5,
    width: '350px',
    flexShrink: 0,
    borderLeft: `1px solid ${theme.colors.gray[1]}`,

    ...(isSidePanel
      ? {
          display: 'none',
        }
      : {
          [theme.fn.smallerThan('md')]: {
            display: 'none',
          },

          [theme.fn.largerThan('md')]: {
            paddingLeft: '32px',
            boxSizing: 'content-box',
          },
        }),
  },
  skeletonHeader: {
    height: 330,

    ...(isSidePanel
      ? {
          height: 370,
        }
      : {
          [theme.fn.smallerThan('sm')]: {
            height: 370,
          },
        }),
  },
}));

export default useStyles;
